import "./eventCard.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function EventCard({ event, onShowClicked, onEditClicked }) {
  const { t } = useTranslation("eventCard");
  const saleEndTimestamp = Number(event?.endDate);
  const hasSaleEnded = !Number.isFinite(saleEndTimestamp) || saleEndTimestamp <= Date.now();
  const isOpen = Boolean(event.open) && !hasSaleEnded;
  const salesEndDate = event?.endDate ? new Date(event.endDate) : null;

  return (
    <div className="saleContainer">
      <p className={isOpen ? "openEvent" : "closeEvent"}>{isOpen ? t("open") : t("closed")}</p>
      {event?.mediaIsVideo ? (
        <video src={event.mediaUrl} autoPlay playsInline loop muted></video>
      ) : (
        <img src={event.mediaUrl || event.imageUrl} alt={t("illustration_picture")} />
      )}
      <p className="eventTitle">{event.name}</p>
      <p className="eventSalesEndDate">
        {t("salesEndDate")}: {salesEndDate && !Number.isNaN(salesEndDate.getTime())
          ? salesEndDate.toLocaleString()
          : t("unknownDate")}
      </p>
      <div className="buttonsContainer">
        <button className="containedButton" onClick={() => onEditClicked(event)}>
          {t("edit")}
        </button>
        <button className="outlinedButton" onClick={() => onShowClicked(event)}>
          {t("show")}
        </button>
      </div>
    </div>
  );
}

EventCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    mediaUrl: PropTypes.string,
    open: PropTypes.bool.isRequired,
    imageUrl: PropTypes.string,
  }).isRequired,
  onShowClicked: PropTypes.func.isRequired,
  onEditClicked: PropTypes.func.isRequired,
};

export default EventCard;
